module.exports = __webpack_public_path__ + "img/homepage-bottom-cta.e622815.jpg";